import AccountProvider from 'account/AccountProvider'
import { Box, Grid, useTheme } from '@mui/material'
import { Outlet, useNavigate } from 'react-router-dom'
import { useEffect } from 'react'
import apiClient from '../services/api'
import { KuknosServer } from '../services/kuknosServer'
import { ReactComponent as AccountVector } from '../assets/images/pki-vector.svg'

import { useAppSelector } from '../hooks/redux'
import { selectAccessToken } from '../redux/slices/authSlice'


function AccountLayout() {
    const currentTheme = useTheme()

    // Utils
    const navigate = useNavigate()

    // Redux
    const accessToken = useAppSelector(selectAccessToken)

    useEffect(() => {
        if (!accessToken) navigate('/auth/login')
    }, [])

    return <AccountProvider
        providerValue={{
            axiosInstance: apiClient,
            theme: currentTheme,
            blockchainServer: KuknosServer,
        }}
    >
        <Grid
            container
            justifyContent="space-between"
            sx={{ height: '100%' }}
        >
            <Grid item xs={12} display="flex" justifyContent="center">
                <Box width="60%">
                    <AccountVector />
                </Box>
            </Grid>

            <Grid
                item
                xs={12}
                justifyContent="center"
                alignItems="center"
                display="flex"
                flexDirection="column"
            >
                <Outlet />
            </Grid>
        </Grid>
    </AccountProvider>
}

export default AccountLayout
